<template>
    <div :class="{'col-md-4': !edit, 'col-md-24': edit, 'not-edit': !edit}" ref="form">
        <div v-if="edit" class="card p-4">
            <file-input v-model="keyResult.image" label="Bild" type="image"></file-input>
            <text-input v-model="keyResult.name" label="Name" ref="name"/>
            <long-text-input v-model="keyResult.description" label="Kurzbeschreibung" ref="description"/>
            <long-text-input v-model="keyResult.longDescription" label="Beschreibung" ref="longDescription"/>
            <div class="form-group">
                <vue-multiselect v-model="keyResult.result" :options="results" track-by="id">
                    <template slot="singleLabel" slot-scope="{option}">
                        {{option.name.text}} - {{option.class}}
                    </template>
                    <template slot="option" slot-scope="{option}">
                        {{option.name.text}} - {{option.class}}
                    </template>
                </vue-multiselect>
            </div>
            <div class="form-group">
                <button class="btn btn-primary" @click.prevent="save">Speichern</button>
                <button class="btn btn-secondary" @click.prevent="edit = false">Schliessen</button>
            </div>
        </div>
        <div class="card" v-else>
            <img class="card-img-top" v-if="keyResult.image" :src="keyResult.image.urls.preview">
            <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{keyResult.name.text}}</h5>
                <p class="card-text" v-if="keyResult.result">{{keyResult.result.name.text}}</p>
                <div style="margin-top: auto;" class="d-flex justify-content-between">
                    <button @click.prevent="startEdit" class="btn btn-primary col">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button @click.prevent="$emit('delete')" class="btn btn-danger col">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import VueMultiselect from "vue-multiselect/src/Multiselect";

export default {
  components: { VueMultiselect },
  props: ["value", "results"],
  data() {
    return {
      edit: false,
      keyResult: this.value
    };
  },
  methods: {
    save() {
      let form = new FormData();
      if (this.keyResult.result)
        form.append("edit_key_result[result]", this.keyResult.result.id);
      if (this.keyResult.image)
        form.append("edit_key_result[image]", this.keyResult.image.id);
      Promise.all([
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
        axios.post(
          "/api/" +
            store.state.language +
            "/key_result/" +
            this.keyResult.id +
            "/edit",
          form
        )
      ]).then(responses => {
        this.edit = false;
        this.$emit("input", this.keyResult);
      });
    },
    startEdit() {
      this.edit = true;
      this.$emit("edit");
    },
    stopEdit() {
      this.edit = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/KeyResult.vue